/**
 * PrEP order partner IDs as stored on Order.partnerId (DynamoDB).
 * Backend dashboard filters with exact equality after trim only — no alias mapping.
 *
 * @see tbd-health-backend PrepDashboardServiceImpl#normalizePartnerId
 * @see PrepDashboardServiceImplTest (uses SFAF)
 * @see CreatePrepOrder (SAGEBRUSH_ATHENA)
 */
export const PREP_PARTNER_OPTIONS = [
  { id: "SAGEBRUSH_ATHENA", name: "Sagebrush Athena" },
  { id: "SFAF", name: "SFAF" },
];
